import React from 'react';
import { colors } from '../../config/colors';

/**
 * Shimmer placeholder for Global Risk Distribution map card.
 * Used as Suspense fallback and inline loading state.
 */
const MapShimmer = ({ className = '', style = {} }) => (
  <div
    className={`rounded-lg overflow-hidden ${className}`}
    style={{
      backgroundColor: colors.map.ocean,
      minHeight: 320,
      ...style,
    }}
  >
    <div
      className="h-full w-full animate-shimmer"
      style={{
        backgroundImage: `linear-gradient(90deg, ${colors.map.shimmerBase} 0%, ${colors.map.shimmerMid} 45%, ${colors.map.shimmerHighlight} 50%, ${colors.map.shimmerMid} 55%, ${colors.map.shimmerBase} 100%)`,
        backgroundSize: '200% 100%',
        backgroundPosition: '200% 50%',
      }}
    />
  </div>
);

export default MapShimmer;
